import numeral from 'numeral';

export function scientificFormat(number) {
  return (number && numeral(number).format('0a')) || '-';
}

export function commaFormatted(num) {
  return numeral(num).format('0,0');
}

export function ierFormat(num) {
  return numeral(num).format('0.0');
}

export function countFormat(number = 0) {
  const numberFormat = number > 1000000 ? '0.0a' : '0a';
  return numeral(number).format(numberFormat);
}

export function formatNumberWithPercentage(numerator, denominator) {
  if (!numerator) return '0%';
  const percentage = numerator / denominator;
  return (percentage < 0.01) ? '<0.1%' : numeral(percentage).format('0.0%');
}

export function ierFormat2DP(num) {
  return numeral(num).format('0.00');
}



/** WEBPACK FOOTER **
 ** ./src/utils/helpers/formatting.js
 **/